var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cc-titled-panel",
    { attrs: { title: _vm.talent.Name, icon: "cci-trait" } },
    [
      _c("p", {
        staticClass: "flavor-text",
        domProps: { innerHTML: _vm._s(_vm.talent.Description) }
      }),
      _vm._v(" "),
      _vm._l(_vm.talent.Ranks, function(r, i) {
        return _c("div", { key: r.Name }, [
          _c("div", { staticClass: "primary white--text" }, [
            _c("span", { staticClass: "heading h3 pl-2" }, [
              _vm._v("\n        " + _vm._s(r.Name) + "\n        "),
              _c("span", { staticClass: "overline white--text" }, [
                _vm._v(" //RANK " + _vm._s(i + 1))
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "light-panel clipped mb-2" },
            [
              _c("cc-talent-rank-item", {
                attrs: { rank: i + 1, "talent-rank": r }
              })
            ],
            1
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }